import './Tabs.css'

interface Tab {
  id: string
  label: React.ReactNode
  disabled?: boolean
}

interface TabsProps {
  tabs: Tab[]
  activeTab: string
  onChange: (id: string) => void
  className?: string
  id?: string
  children?: React.ReactNode
}

export default function Tabs({
  tabs,
  activeTab,
  onChange,
  className = '',
  id,
  children
}: TabsProps) {
  return (
    <div id={id} className={`tabs ${className}`}>
      <div role="tablist" className="tabs-list">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            role="tab"
            className="tabs-tab"
            aria-selected={tab.id === activeTab}
            aria-disabled={tab.disabled}
            disabled={tab.disabled}
            onClick={() => !tab.disabled && onChange(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="tabs-panel">{children}</div>
    </div>
  )
}
